import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type BadgeVariant =
  | 'neutral'
  | 'brand'
  | 'accent'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'solid';

/**
 * `<nb-badge>` — the design-system badge/pill (Mockup `.badge` + variants).
 *
 * A compact 24px-tall label. Project an optional leading `<nb-icon>` followed by
 * text; the icon is sized to 13px / stroke 2.2 via `--nb-icon-size`. Status
 * meaning is carried by the icon + text, never by colour alone, so always pair a
 * status variant (success/warning/danger/info) with a matching icon and label.
 *
 * @example
 * <nb-badge variant="success"><nb-icon [icon]="Check"/> Aktiv</nb-badge>
 * <nb-badge>Utkast</nb-badge>
 */
@Component({
  selector: 'nb-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'badge',
    '[class.neutral]': "variant() === 'neutral'",
    '[class.brand]': "variant() === 'brand'",
    '[class.accent]': "variant() === 'accent'",
    '[class.success]': "variant() === 'success'",
    '[class.warning]': "variant() === 'warning'",
    '[class.danger]': "variant() === 'danger'",
    '[class.info]': "variant() === 'info'",
    '[class.solid]': "variant() === 'solid'",
  },
  template: `<ng-content />`,
  styleUrl: './badge.css',
})
export class NbBadge {
  readonly variant = input<BadgeVariant>('neutral');
}
